const ERBA_TEAL = "#009999";
const TRANSASIA_BLUE = "#084C71";

export default function CombinedLogo({ size = "default" }) {
  const isSmall = size === "small";
  
  return (
    <div className="flex items-center gap-2" data-testid="combined-logo">
      {/* Erba Mannheim */}
      <div className="flex items-center gap-1">
        <div className="relative" style={{ width: isSmall ? 18 : 24, height: isSmall ? 18 : 24 }}>
          <div className="absolute inset-0 rounded-full border-2" style={{ borderColor: ERBA_TEAL, borderStyle: "solid", borderBottomStyle: "dashed" }} />
        </div>
        <div className="leading-none">
          <span className={`font-bold ${isSmall ? "text-sm" : "text-base"}`} style={{ color: ERBA_TEAL, fontFamily: "system-ui, sans-serif" }}>
            Erba
          </span>
          <span className={`block ${isSmall ? "text-[7px]" : "text-[8px]"} text-gray-400 tracking-wide`} style={{ fontFamily: "Georgia, serif" }}>
            Mannheim
          </span>
        </div>
      </div>
      {/* Divider */}
      <div className={`${isSmall ? "h-6" : "h-8"} w-px bg-gray-300`} />
      {/* TRANSASIA */}
      <div className="leading-none">
        <span className={`font-black ${isSmall ? "text-sm" : "text-lg"} tracking-wide`} style={{ color: TRANSASIA_BLUE }}>
          TRANSASIA
        </span>
        <span className={`block ${isSmall ? "text-[6px]" : "text-[7px]"} tracking-wider`} style={{ color: "#555" }}>
          No.1 Diagnostic Company in India
        </span>
      </div>
    </div>
  );
}
